import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwParamSet";

/**
 * VuwSheet (extends VuwFade)
 * @options
 * - {Object} dataParams
 * - {String} title
 * - {Array} inpsStyle
 * - {Array} inpsStyleOption
 * - {Object} btns: {
 * 		"{key}": {
 * 			text: {string} button text,
 * 			func: {function} click event callback
 * 		}
 * - {String} activeClassName
 */
vuwer.appendKlass("VuwSheet", {
	btns: {
		reset: {
			text: "reset",
			func: function reset() {
				this.clearVal();
			}
		},
		next: {
			text: "next",
			func: function next() {
				!this.validate().count && alert("OK!");
			}
		}
	},
	activeClassName: "is-active",
	
	_initialize(opt) {
		if( u_.isObject(opt) ) {
			if( u_.isFunction(opt.onReadyFirst) ) {
				this._onReadyFirst = opt.onReadyFirst;
				delete opt.onReadyFirst;
			}
			
			if( u_.isFunction(opt.onReadyLast) ) {
				this._onReadyLast = opt.onReadyLast;
				delete opt.onReadyLast;
			}
		}
		
		if( Klass("VuwSheet").parent._initialize.call(this, opt) ) {
			const childProp = {
				vuwType: "paramSet"
			};
			
			if( u_.isObject(this.dataParams) ) {
				// [add paramSet]
				const joinTo = [];
				Object.keys(this.dataParams).forEach(pk => {
					childProp.paramInfo = this.dataParams[pk];
					if( childProp.paramInfo.joinTo && u_.isString(childProp.paramInfo.joinTo) ) {
						joinTo.push(pk);
					} else {
						this.add(pk, childProp);
					}
				});
				
				// [add sub param]
				joinTo.forEach(pk => {
					childProp.paramInfo = this.dataParams[pk];
					const vuw = this.get(childProp.paramInfo.joinTo);
					!!vuw && vuw.add(pk, childProp);
				});
			}
			
			// [add onChangeState callback]
			this.onChangeState(state => {
				if( this.$self && u_.isBoolean(state.visible) ) {
					this.$self.toggleClass(this.activeClassName, state.visible);
					state.visible && setTimeout(() => {
						const selects = this.getField("select", true);
						Object.keys(selects).forEach(pk => {
							!!u_.isFunction(selects[pk].updWidth) && selects[pk].updWidth();
						});
					}, this.delay);
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	async onReadyFirst($self) {
		if(!$self) {
			return false;
		}
		
		// [render this]
		await this.setState("rendering", true);
		
		return !u_.isFunction(this._onReadyFirst) || this._onReadyFirst(this.$self);
	},
	
	async onReadyLast($self) {
		if( $self && u_.isObject(this.dataParams) ) {
			const grid = {
				s: {
					conf: {
						s: 1, m: 1, l: 2, f: 2
					},
					count: 0
				},
				w: {
					conf: {
						s: 1, m: 2, l: 3, f: 4
					},
					count: 0
				}
			};
			
			const methods = [];
			
			// [render child paramSet]
			this.getChildren().forEach(vuw => {
				if( vuw instanceof Klass("VuwParamSet") ) {
					const data = {
						s: grid.s.conf[vuw.paramInfo.inpSize],
						w: grid.w.conf[vuw.paramInfo.inpSize]
					};
					
					// calc grid
					(grid.s.count + data.s > grid.s.conf.f) && (grid.s.count = 0);
					(grid.w.count + data.w > grid.w.conf.f) && (grid.w.count = 0);
					
					methods.push( vuw.setState("gridLeft", {
						sp: !grid.s.count,
						pc: !grid.w.count
					}) );
					
					grid.s.count += data.s;
					grid.w.count += data.w;
				}
			});
			
			await Promise.all(methods);
		}
		
		return !u_.isFunction(this._onReadyLast) || this._onReadyLast(this.$self);
	},
	
	_createInpsList() {
		if( !u_.isObject(this.dataParams) ) {
			return false;
		}
		
		const cls = ["inps-list"];
		Array.isArray(this.inpsStyleOption) && cls.push(...this.inpsStyleOption);
		
		const $list = $("<ul/>").addClass( cls.join(" ") );
		(u_.isString(this.title) && this.title) && $list.attr("data-title", this.title);
		(u_.isString(this.inpsStyle) && this.inpsStyle) && $list.attr("data-style", this.inpsStyle);
		
		this.getChildren().forEach(vuw =>{
			if( vuw instanceof Klass("VuwParamSet") ) {
				vuw.$self = $("<li/>").appendTo($list);
			}
		});
		
		return $list;
	},
	
	_createBtns() {
		if( !u_.isObject(this.btns) ) {
			return false;
		}
		
		const keys = Object.keys(this.btns);
		if(!keys.length) {
			return false;
		}
		
		const $btns = $("<p/>").addClass("btns");
		
		keys.forEach(k => {
			if(this.btns[k].text) {
				$("<a/>").addClass(`btn-${k}`).attr({
					"href": "./",
					"data-func": k
				}).append(
					$("<span/>").html( $.parseHTML(this.btns[k].text) )
				).appendTo($btns);
				
				if(k === "next") {
					$btns.children(".btn-next").append( $("<em/>").addClass("spinner") );
				}
			}
		});
		
		return $btns;
	},
	
	getField(fieldType, deep) {
		return Klass("VuwForm").prototype.getField.call(this, fieldType, deep);
	},
	
	_getKeyOfValForField(vuwField, val) {
		return this.getForm()._getKeyOfValForField(vuwField, val);
	},
	
	setVal(val, callback) {
		return Klass("VuwForm").prototype.setVal.call(this, val, async () => {
			u_.isFunction(callback) && await callback.call(this);
			
			const vuwForm = this.getForm();
			if( vuwForm && u_.isFunction(vuwForm.onUpdate) ) {
				vuwForm.onUpdate(vuwForm.getVal(), vuwForm.config);
			}
		});
	},
	
	getVal(paramKey) {
		return Klass("VuwForm").prototype.getVal.call(this, paramKey);
	},
	
	clearVal() {
		const vuwForm = this.getForm();
		Klass("VuwForm").prototype.clearVal.call(this);
		
		if( vuwForm && u_.isFunction(vuwForm.onUpdate) ) {
			vuwForm.onUpdate(vuwForm.getVal(), vuwForm.config);
		}
		return this;
	},
	
	validate() {
		const vuwForm = this.getForm();
		
		this.scrollBuffer = vuwForm.scrollBuffer;
		
		const errObj = Klass("VuwForm").prototype.validate.call(this);
		if( vuwForm && u_.isFunction(vuwForm.onValidate) ) {
			vuwForm.onValidate(this.$self, errObj, vuwForm.config);
		}
		return errObj;
	},
	
	getForm() {
		return Klass("VuwField").prototype.getForm.call(this);
	},
	
	render($elm, state) {
		if(state.rendering) {
			delete state.rendering;
			$elm = $("<div/>").addClass("vuw-sheet").attr("data-sheet", this.name);
			
			// [append inpsList]
			this.$inpsList = this._createInpsList();
			!!this.$inpsList && this.$inpsList.appendTo($elm);
			
			// [append btns]
			this.$btns = this._createBtns();
			if(this.$btns) {
				this.$btns.appendTo($elm);
				$.data(this.$btns.get(0), "vuwSheet", this);
				
				// [add click events for btns]
				this.$btns.on("click", "a[data-func]", e => {
					const $elm = $(e.currentTarget);
					if( $elm.hasClass("is-disable") ) {
						return false;
					}
					
					e.preventDefault();
					
					const vuw = $.data(e.delegateTarget, "vuwSheet");
					const k = $elm.attr("data-func");
					
					if( u_.isFunction(vuw.btns[k].func) ) {
						vuw.btns[k].func.call(vuw, e.currentTarget);
					}
				});
			}
		}
		
		return $elm;
	}
}, "VuwFade");
